import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.jsx';
import './config/axiosConfig';  // Register axios interceptors (must be before any API calls)
import './index.css';
import router from './routes/index.jsx';
import { startVersionWatch } from './shell/app-status/versionCheck.js';

// Notice a deploy while this tab is open: a "new version" prompt, and the next page change loads fresh.
startVersionWatch(router);

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);